import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { ERdvBreadcrumbWidget } from './ERdvBreadcrumbWidget';
import { ERdvNavigationWidget } from './ERdvNavigationWidget';
import { ERdvFormWidget } from './ERdvFormWidget';
import { ErdvErrors } from '../../Models/Enum/ErdvErrors';

interface IERdvPageWidgetProps {
    description: string;
    code: number;
    serviceType: number;
    isNissMandatory: string;
    dictMeetUsTitle: string;
    dictIdentificationTitle: string;
    dictAgencyTitle: string;
    dictDatasTitle: string;
    dictComplementaryTitle: string;
    dictConfirmationTitle: string;
    dictPreviousLabel: string;
    dictNextLabel: string;
    dictIdentificationQuestion1Label: string;
    dictIdentificationQuestion2Label: string;
    dictIdentificationQuestionTitle: string;
    dictIdentification101Label: string;
    dictIdentification103Label: string;
    dictIdentification104Label: string;
    dictAgencyHighTitle: string;
    dictAgencyDesc: string;
    dictTitleLabel: string;
    dictNameLabel: string;
    dictSurnameLabel: string;
    dictNissLabel: string;
    dictPostCodeLabel: string;
    dictPhoneLabel: string;
    dictMailLabel: string;
    dictAgencyLabel: string;
    dictDateLabel: string;
    dictHoursLabel: string;
    dictYesLabel: string;
    dictNoLabel: string;
    dictDatasHighTitle: string;
    dictNissHelp: string;
    dictMailHelp: string;
    dictTitleMr: string;
    dictTitleMrs: string;
    dictTitleMs: string;
    dictConfirmationTitle1: string;
    dictConfirmationTitle2: string;
    dictConfirmationTitle3: string;
    dictConfirmationDesc1: string;
    dictConfirmationDesc2: string;
    dictConfirmationDesc3: string;
    dictConfirmationDesc4: string;
    dictConfirmationDesc5: string;
    dictConfirmationDesc6: string;
    dictConfirmationDesc7: string;
    dictConfirmationDesc8: string;
    dictConfirmationDesc9: string;
    dictConfirmationDesc10: string;
    dictConfirmationDesc11: string;
    dictComplementaryTitle1: string;
    dictComplementaryDesc: string;
    dictCommentaryLabel: string;
    dictCodeRdvLabel: string;
    dictServiceLabel: string;
    dictSiteLabel: string;
    dictConfirmationInfo1: string;
    dictConfirmationInfo2: string;
    dictConfirmationHelp: string;
    dictDateOfBirthLabel: string;
    dictTitleTip1: string;
    dictTitleTip2: string;
    dictDescTip1: string;
    dictDescTip2: string;
    dictNoDateLabel: string;
    dictLockTimeError: string;
    lang: string;
}

interface IERdvPageWidgetState {
    formStep: number;
    showValidateButton: boolean;
    hideFirstStep: boolean;
    resetEnabled: boolean;
    isNissMandatory: boolean;
    captchaToken?: string | null;
    error?: ErdvErrors | undefined;
}

export class ERdvPageWidget extends Component<
    IERdvPageWidgetProps,
    IERdvPageWidgetState
> {
    constructor(props: IERdvPageWidgetProps) {
        super(props);
        this.state = {
            formStep: +this.props.code === 0 ? 0 : 1,
            hideFirstStep: +this.props.code !== 0,
            showValidateButton: false,
            resetEnabled: false,
            isNissMandatory: this.props.isNissMandatory === 'True',
            error: undefined,
        };
    }

    handleNavTo(val: number, error?: ErdvErrors) {
        console.log(error);
        this.setState({ formStep: +val, error });
    }

    showValidateButton = (val: boolean) => {
        this.setState({ showValidateButton: val });
    };

    changeLinks = () => {
        this.setState({ resetEnabled: true });
    };

    restoreLinks = () => {
        this.setState({ resetEnabled: false });
    };

    setCaptcha = (captchaToken: string) => {
        this.setState({ captchaToken: captchaToken });
    };

    render() {
        const dictStep = [
            this.props.dictIdentificationTitle,
            this.props.dictAgencyTitle,
            this.props.dictDatasTitle,
            this.props.dictComplementaryTitle,
            this.props.dictConfirmationTitle,
        ];

        return (
            <div className="pb-5">
                <ERdvBreadcrumbWidget
                    title={this.props.dictMeetUsTitle}
                    formStep={this.state.formStep}
                    dictSteps={dictStep}
                    handleNavTo={(val: number) => this.handleNavTo(val)}
                    hideFirstStep={this.state.hideFirstStep}
                    resetEnabled={this.state.resetEnabled}
                ></ERdvBreadcrumbWidget>

                <ERdvFormWidget
                    description={this.props.description}
                    dictIdentificationQuestionTitle={
                        this.props.dictIdentificationQuestionTitle
                    }
                    dictIdentificationQuestion1Label={
                        this.props.dictIdentificationQuestion1Label
                    }
                    dictIdentificationQuestion2Label={
                        this.props.dictIdentificationQuestion2Label
                    }
                    dictIdentification101Label={
                        this.props.dictIdentification101Label
                    }
                    dictIdentification103Label={
                        this.props.dictIdentification103Label
                    }
                    dictIdentification104Label={
                        this.props.dictIdentification104Label
                    }
                    dictAgencyTitle={this.props.dictAgencyHighTitle}
                    dictAgencyDesc={this.props.dictAgencyDesc}
                    dictTitleLabel={this.props.dictTitleLabel}
                    dictNameLabel={this.props.dictNameLabel}
                    dictSurnameLabel={this.props.dictSurnameLabel}
                    dictNissLabel={this.props.dictNissLabel}
                    dictPostCodeLabel={this.props.dictPostCodeLabel}
                    dictPhoneLabel={this.props.dictPhoneLabel}
                    dictMailLabel={this.props.dictMailLabel}
                    dictAgencyLabel={this.props.dictAgencyLabel}
                    dictDateLabel={this.props.dictDateLabel}
                    dictHoursLabel={this.props.dictHoursLabel}
                    dictYesLabel={this.props.dictYesLabel}
                    dictNoLabel={this.props.dictNoLabel}
                    dictDatasTitle={this.props.dictDatasHighTitle}
                    dictNissHelp={this.props.dictNissHelp}
                    dictMailHelp={this.props.dictMailHelp}
                    dictTitleMr={this.props.dictTitleMr}
                    dictTitleMrs={this.props.dictTitleMrs}
                    dictTitleMs={this.props.dictTitleMs}
                    dictConfirmationTitle1={this.props.dictConfirmationTitle1}
                    dictConfirmationTitle2={this.props.dictConfirmationTitle2}
                    dictConfirmationTitle3={this.props.dictConfirmationTitle3}
                    dictConfirmationDesc1={this.props.dictConfirmationDesc1}
                    dictConfirmationDesc2={this.props.dictConfirmationDesc2}
                    dictConfirmationDesc3={this.props.dictConfirmationDesc3}
                    dictConfirmationDesc4={this.props.dictConfirmationDesc4}
                    dictConfirmationDesc5={this.props.dictConfirmationDesc5}
                    dictConfirmationDesc6={this.props.dictConfirmationDesc6}
                    dictConfirmationDesc7={this.props.dictConfirmationDesc7}
                    dictConfirmationDesc8={this.props.dictConfirmationDesc8}
                    dictConfirmationDesc9={this.props.dictConfirmationDesc9}
                    dictConfirmationDesc10={this.props.dictConfirmationDesc10}
                    dictConfirmationDesc11={this.props.dictConfirmationDesc11}
                    dictComplementaryTitle={this.props.dictComplementaryTitle1}
                    dictComplementaryDesc={this.props.dictComplementaryDesc}
                    dictCommentaryLabel={this.props.dictCommentaryLabel}
                    dictCodeRdvLabel={this.props.dictCodeRdvLabel}
                    dictServiceLabel={this.props.dictServiceLabel}
                    dictSiteLabel={this.props.dictSiteLabel}
                    dictConfirmationInfo1={this.props.dictConfirmationInfo1}
                    dictConfirmationInfo2={this.props.dictConfirmationInfo2}
                    dictConfirmationHelp={this.props.dictConfirmationHelp}
                    dictDateOfBirthLabel={this.props.dictDateOfBirthLabel}
                    dictTitleTip1={this.props.dictTitleTip1}
                    dictTitleTip2={this.props.dictTitleTip2}
                    dictDescTip1={this.props.dictDescTip1}
                    dictDescTip2={this.props.dictDescTip2}
                    dictNoDateLabel={this.props.dictNoDateLabel}
                    dictLockTimeError={this.props.dictLockTimeError}
                    formStep={this.state.formStep}
                    lang={this.props.lang}
                    showValidateButton={this.showValidateButton}
                    handleNavTo={(val: number, error?: ErdvErrors) =>
                        this.handleNavTo(val, error)
                    }
                    code={this.props.code}
                    serviceType={this.props.serviceType}
                    changeLinks={this.changeLinks}
                    isNissMandatory={this.state.isNissMandatory}
                    captchaToken={this.state.captchaToken}
                    error={this.state.error}
                ></ERdvFormWidget>

                <ERdvNavigationWidget
                    formStep={this.state.formStep}
                    maxIndex={dictStep.length - 1}
                    handleNavTo={(val: number) => this.handleNavTo(val)}
                    dictPreviousLabel={this.props.dictPreviousLabel}
                    dictNextLabel={this.props.dictNextLabel}
                    hideFirstStep={this.state.hideFirstStep}
                    showValidateButton={this.state.showValidateButton}
                    resetEnabled={this.state.resetEnabled}
                    restoreLinks={this.restoreLinks}
                    setCaptcha={this.setCaptcha}
                ></ERdvNavigationWidget>
            </div>
        );
    }
}

WidgetHelper.register(ERdvPageWidget, 'erdv-page-widget');
